
import React from "react";
import { XCircle } from "lucide-react";
import { StudentEvent } from "../types";
import { useLanguage } from "@/components/LanguageContext";
import { useTranslations } from "@/hooks/useTranslations";
import { formatEventDate } from "../utils/eventUtils";

interface CancelledEventsListProps {
  events: StudentEvent[];
  handleEventClick: (event: StudentEvent) => void;
}

export const CancelledEventsList: React.FC<CancelledEventsListProps> = ({ 
  events, 
  handleEventClick 
}) => {
  const { language } = useLanguage();
  const { t } = useTranslations("schedule");

  if (events.length === 0) return null;

  return (
    <div className="mt-8 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
      <div className="bg-gray-100 dark:bg-gray-800 px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <h3 className="font-medium text-gray-900 dark:text-gray-100">{t("studentSchedule.cancelledEvents")}</h3>
      </div>
      
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        {events.map(event => (
          <div 
            key={event.id} 
            className="p-4 hover:bg-gray-50 dark:hover:bg-gray-800/60 cursor-pointer"
            onClick={() => handleEventClick(event)}
          >
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium text-gray-900 dark:text-gray-100">
                  {event.type === 'request' ? t("studentSchedule.requestRejected") : t("studentSchedule.classCancelled")}
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                  {formatEventDate(event.start_time, language)}
                </p>
                {event.cancellation_reason && (
                  <p className="text-sm text-gray-600 dark:text-gray-300 mt-2 italic">
                    "{event.cancellation_reason}"
                  </p>
                )}
              </div>
              <XCircle className="h-5 w-5 text-red-500 dark:text-red-400 flex-shrink-0" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
